import { Pagination, Table, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import React from "react";

function CovinTable({ covinData, covinLoading, page, newPage }) {
  const columns = [
    {
      title: "Agent Email",
      width: 200,
      dataIndex: "agent_email",
      key: "agent_email",
      fixed: "left",
      render: (_, data) => (
        <Tooltip placement="top" title={data.agent_email}>
          <div className="text-truncate text-break">{data.agent_email}</div>
        </Tooltip>
      ),
    },
    {
      title: "Date",
      width: 120,
      dataIndex: "createdAt",
      key: "createdAt",
      fixed: "left",
      render: (_, data) => (
        <span>{moment(data.createdAt).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      title: "Order Id",
      width: 100,
      dataIndex: "order_id",
      key: "order_id",
      fixed: "left",
    },
    {
      title: "Talk Time",
      width: 100,
      dataIndex: "talk_time",
      key: "talk_time",
      fixed: "left",
      render: (talk_time) => `${(talk_time / 60).toFixed(2)} min`,
    },
    {
      title: "Order Number",
      dataIndex: "order_number",
      key: "order_number",
      width: 150,
    },
    {
      title: "Attempt to Reorder",
      dataIndex: "attempt_to_reorder",
      key: "attempt_to_reorder",
      width: 180,
    },
    {
      title: "App User",
      dataIndex: "app_user",
      key: "app_user",
      width: 150,
    },
    {
      title: "Follow Up Second Call",
      dataIndex: "follow_up_second_call",
      key: "follow_up_second_call",
      width: 190,
    },
    {
      title: "Abrupt Call Ending",
      dataIndex: "abrupt_call_ending",
      key: "abrupt_call_ending",
      width: 180,
    },
    {
      title: "Serum Prescribed",
      dataIndex: "serum_prescribed",
      key: "serum_prescribed",
      width: 170,
    },
    {
      title: "Minoxidil Prescribed",
      dataIndex: "minoxidil_prescribed",
      key: "minoxidil_prescribed",
      width: 170,
    },
    {
      title: "Recap Prescribed",
      dataIndex: "recap_prescribed",
      key: "recap_prescribed",
      width: 170,
    },
    {
      title: "Keto Lotion Prescribed",
      dataIndex: "keto_lotion_prescribed",
      key: "keto_lotion_prescribed",
      width: 190,
    },
    {
      title: "Customer Upload Scalp Image",
      dataIndex: "customer_has_uploaded_scalp_picture",
      key: "customer_has_uploaded_scalp_picture",
      width: 250,
    },
    {
      title: "Product Purchased",
      dataIndex: "product_purchased",
      key: "product_purchased",
      width: 180,
      render: (_, data) => (
        <Tooltip placement="left" title={data.product_purchased} overlayStyle={{ maxWidth: 600 }}>
        <div className="text-truncate text-break">{data.product_purchased}</div>
        </Tooltip>
      ),
    },
    {
      title: "Call Provider",
      dataIndex: "call_provider",
      key: "call_provider",
      width: 150,
    },
    {
      title: "Engagement Id",
      dataIndex: "engagement_id",
      key: "engagement_id",
      width: 150,
      render: (_, data) => (
        <Tooltip placement="top" title={data.engagement_id}>
        <div className="text-truncate text-break">{data.engagement_id}</div>
        </Tooltip>
      ),
    },
    {
      title: "Call Id",
      dataIndex: "call_id",
      key: "call_id",
      width: 150,
      render: (_, data) => (
        <Tooltip placement="top" title={data.call_id}>
        <div className="text-truncate text-break">{data.call_id}</div>
        </Tooltip>
      ),
    },
    {
      title: "Calling Number",
      dataIndex: "callee_number",
      key: "callee_number",
      width: 150,
    },
    {
      title: "Call Type",
      dataIndex: "call_type",
      key: "call_type",
      width: 150,
    },
    {
      title: "Call Time",
      dataIndex: "call_time",
      key: "call_time",
      width: 200,
    },
    {
      title: "Type Of Call",
      dataIndex: "type_of_call",
      key: "type_of_call",
      width: 200,
    },
    {
      title: "Time Line Tag",
      dataIndex: "timeline_tag",
      key: "timeline_tag",
      width: 150,
    },
    {
      title: "Customer Dandruff Issue",
      dataIndex: "customer_with_dandruff_issue",
      key: "customer_with_dandruff_issue",
      width: 250,
    },
    {
      title: "Customer Gut Health Issue",
      dataIndex: "customer_with_gut_health_issue",
      key: "customer_with_gut_health_issue",
      width: 250,
    },
    {
      title: "Nasal Girth Completion",
      dataIndex: "nasal_girth_completion",
      key: "nasal_girth_completion",
      width: 250,
    },
    {
      title: "Vitamin Stoppage",
      dataIndex: "vitamin_stoppage",
      key: "vitamin_stoppage",
      width: 250,
    },
    {
      title: "Minoxidil/Recap Prescribed",
      dataIndex: "minoxidil_or_recap_prescribed",
      key: "minoxidil_or_recap_prescribed",
      width: 250,
    },
    {
      title: "Last Order Tag",
      dataIndex: "last_order_tag",
      key: "last_order_tag",
      width: 250,
    },
    {
      title: "3 month plus gap",
      dataIndex: "three_month_plus_gap",
      key: "three_month_plus_gap",
      width: 250,
    },
    {
      title: "Switch in Serum",
      dataIndex: "switch_in_serum",
      key: "switch_in_serum",
      width: 250,
    },
    {
      title: "Expectation Setting",
      dataIndex: "expectation_setting",
      key: "expectation_setting",
      width: 250,
    },
    {
      title: "Recording",
      key: "recording_file_url",
      width: 350,
      render: (_, record) => (
        <div className="d-flex gap-1 py-n2 justify-content-center align-items-center">
          <audio
            id={`audio-${record.key}`}
            src={record.recording_file_url}
            controls
          ></audio>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={_.get(covinData, "data", [])}
        scroll={{
          x: 1500,
          y:600
        }}
        loading={covinLoading}
        pagination={false}
      />
      <div className="text-center">
        <Pagination
          current={page}
          pageSize={10}
          total={_.get(covinData, "totalCount")}
          onChange={(pageNumber) => newPage(pageNumber)}
          style={{ marginTop: 20 }}
        />
      </div>
    </div>
  );
}

export default CovinTable;
